// extracted by mini-css-extract-plugin
module.exports = {"Loans":"Loans_Loans__1m3tA","action":"Loans_action__38RZJ","lighter":"Loans_lighter__1Lm62"};